import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bt_005_d",
  "use": "icon-bt_005_d-usage",
  "viewBox": "0 0 82 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 82 33\" id=\"icon-bt_005_d\"><defs><style>#icon-bt_005_d .cls-1{fill:none;opacity:0;}#icon-bt_005_d .cls-2{fill:#aaa;}</style></defs><g id=\"icon-bt_005_d_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-bt_005_d_icon\"><path class=\"cls-1\" d=\"M82,33H0V0H82V33Z\" /><path class=\"cls-2\" d=\"M79,2V30H2V2H79m1-1H1V31H80V1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol